@if (isSpinner) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<button class="btn btn-primary" (click)="downloadAsPDF();">Export To PDF</button>
<div id="pdfTable" #pdfTable class="row m-0 wifi-details">
  <h1 class="wifi-logo">
    <i class="pi pi-wifi"></i>
  </h1>
  <h1 class="wifi-heading"><b>Connect To WIFI</b></h1>

  <div style="align-content: center;" class="wifi-name">
    @if (property?.instruction?.wifiName != null && property?.instruction?.wifiName != '') {
      <h5>WIFI Name (SSID)</h5>
    }
    @if (property?.instruction?.wifiName != null && property?.instruction?.wifiName != '') {
      <p>{{property?.instruction?.wifiName}}</p>
      }<br/>

      @if (property?.instruction?.wifiName5g != null && property?.instruction?.wifiName5g != '') {
        <h5>WIFI Name 5G</h5>
      }
      @if (property?.instruction?.wifiName5g != null && property?.instruction?.wifiName5g != '') {
        <p>{{property?.instruction?.wifiName5g}}</p>
      }
    </div>

    <div style="align-content: center;" class="wifi-pass">
      @if (property?.instruction?.wifiPassword != null && property?.instruction?.wifiPassword != '') {
        <h2>Password</h2>
      }
      @if (property?.instruction?.wifiPassword != null && property?.instruction?.wifiPassword != '') {
        <p>{{property?.instruction?.wifiPassword}}</p>
      }
    </div>


    <!-- <div class="col-lg-12">
    WIFI Name (SSID):  {{property?.instruction?.wifiName}}
  </div>
  <div class="col-lg-12">
    WIFI Name 5G: {{property?.instruction?.wifiName5g}}
  </div>
  <div class="col-lg-12">
    WIFI Password: {{property?.instruction?.wifiPassword}}
  </div> -->

  @if (qrCode != null && qrCode != undefined) {
    <div style="align-content: center;" class="col-lg-12 wifi-img">
      <img src="data:image/png;base64, {{qrCode}}" alt="" />
    </div>
  }
  <div style="align-content: center;">
    <h5><b>scan to connect</b></h5>
  </div>
</div>